import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';

function PageLoader({
  loading = true,
  onComplete,
  logo = 'assets/img/logo/logo-white.png',
}) {
  const rootRef = useRef(null);
  const barRef = useRef(null);
  const counterRef = useRef(null);
  const progress = useRef({ value: 0 });
  const progressTween = useRef(null);
  const onCompleteRef = useRef(onComplete);

  onCompleteRef.current = onComplete;

  const render = () => {
    const v = progress.current.value;
    if (barRef.current) gsap.set(barRef.current, { scaleX: v / 100 });
    if (counterRef.current) counterRef.current.textContent = `${Math.round(v)}%`;
  };

  // Lock scroll while the loader is on screen
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  // Intro, idle animation, and mouse parallax
  useEffect(() => {
    const root = rootRef.current;

    const ctx = gsap.context(() => {
      // Logo entrance
      gsap.from('.loader-logo', {
        opacity: 0,
        y: 40,
        scale: 0.7,
        rotateX: -60,
        transformPerspective: 600,
        duration: 1,
        ease: 'back.out(1.6)',
      });

      gsap.from('.loader-meta', {
        opacity: 0,
        y: 12,
        delay: 0.35,
        duration: 0.6,
        ease: 'power2.out',
      });

      // Soft breathing pulse on the wrapper
      gsap.to('.loader-logo-wrap', {
        scale: 1.05,
        duration: 1.3,
        yoyo: true,
        repeat: -1,
        ease: 'sine.inOut',
        delay: 1,
      });

      // Fake progress: climbs towards 90% while the page is loading
      progress.current.value = 0;
      progressTween.current = gsap.to(progress.current, {
        value: 90,
        duration: 4,
        ease: 'power2.out',
        onUpdate: render,
      });

      // Interactive: logo drifts gently toward the cursor
      const xTo = gsap.quickTo('.loader-logo-wrap', 'x', { duration: 0.6, ease: 'power3' });
      const yTo = gsap.quickTo('.loader-logo-wrap', 'y', { duration: 0.6, ease: 'power3' });

      const onMove = (e) => {
        const nx = e.clientX / window.innerWidth - 0.5;
        const ny = e.clientY / window.innerHeight - 0.5;
        xTo(nx * 30);
        yTo(ny * 30);
      };

      root.addEventListener('pointermove', onMove);
      return () => root.removeEventListener('pointermove', onMove);
    }, root);

    return () => ctx.revert();
  }, []);

  // Exit sequence, triggered when `loading` becomes false
  useEffect(() => {
    if (loading) return;

    const ctx = gsap.context(() => {
      progressTween.current?.kill();

      const tl = gsap.timeline({
        onComplete: () => onCompleteRef.current?.(),
      });

      tl.to(progress.current, {
        value: 100,
        duration: 0.5,
        ease: 'power2.inOut',
        onUpdate: render,
      })
        // logo flies out
        .to(
          '.loader-logo-wrap',
          { scale: 1.25, opacity: 0, y: -30, duration: 0.55, ease: 'power3.in' },
          '+=0.1'
        )
        .to('.loader-meta', { opacity: 0, y: 10, duration: 0.3 }, '<')
        // curtains split open
        .to(
          '.loader-panel-top',
          { yPercent: -100, duration: 0.9, ease: 'power4.inOut' },
          '-=0.15'
        )
        .to('.loader-panel-bottom', { yPercent: 100, duration: 0.9, ease: 'power4.inOut' }, '<');
    }, rootRef);

    return () => ctx.revert();
  }, [loading]);

  return (
    <div className="page-loader" ref={rootRef}>
      <div className="loader-panel loader-panel-top" />
      <div className="loader-panel loader-panel-bottom" />

      <div className="loader-content">
        <div className="loader-logo-wrap">
          <img src={logo} alt="Loading..." className="loader-logo" />
        </div>

        <div className="loader-meta">
          <div className="loader-progress">
            <span className="loader-progress-bar" ref={barRef} />
          </div>
          <div className="loader-counter" ref={counterRef}>
            0%
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageLoader;




// import { useEffect, useState } from 'react';
// function PageLoader() {
//   const [loading, setLoading] = useState(true);
//   const [hidden, setHidden] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setLoading(false);
//     }, 1800);

//     return () => clearTimeout(timer);
//   }, []);

//   useEffect(() => {
//     if (!loading) {
//       const timer = setTimeout(() => {
//         setHidden(true);
//       }, 700);

//       return () => clearTimeout(timer);
//     }
//   }, [loading]);

//   if (hidden) return null;

//   return (
//     <div className={`page-loader ${!loading ? 'loader-exit' : ''}`}>
//       <div className="loader-content">
//         <img src="assets/img/logo/logo-white.png" alt="Loading..." className="loader-logo" />

//         <div className="loader-progress">
//           <span></span>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default PageLoader;